import App from "./App";
import {AuthProvider} from "react-oidc-context";
import {oidcConfig} from "./_config";

export function SecuredApp() {
    return (<AuthProvider {...oidcConfig}>
        <App/>
    </AuthProvider>)
}